const Apuracao = () => import('../../spa/apuracao/Apuracao');

export default {
  path: 'apuracao',
  name: 'apuracao',
  component: Apuracao,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/apuracao.js